import { useIntl } from 'lib/intl-utils'
import { FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import AvailableMalls from 'components/landing/sellematics/blocks/AvailableMalls'
import Services from 'components/landing/sellematics/blocks/Services'
import ForBrands from 'components/landing/sellematics/blocks/ForBrands'
import ForDistributors from 'components/landing/sellematics/blocks/ForDistributors'
import PriceManagement from 'components/landing/sellematics/blocks/PriceManagement'
import Stats from 'components/landing/sellematics/blocks/Stats'
import SellmonitorPlug from 'components/landing/sellematics/blocks/SellmonitorPlug'
import WeWorkWith from 'components/landing/sellematics/blocks/WeWorkWith'
import SellematicsTestimonials from 'components/landing/sellematics/blocks/SellematicsTestimonials'
import DemoContactForm from 'components/landing/sellematics/blocks/DemoContactForm'

const SellematicsIndexPage: FC = () => {
  const ctx = useUserContext()
  const { t } = useIntl()

  const isSellematics = ctx.theme.hostType === 'sellematics'

  if (!isSellematics) {
    return null
  }

  return (
    <>
      <AvailableMalls />
      <Services />
      <ForBrands />
      <ForDistributors />
      <PriceManagement />
      <Stats />
      <SellmonitorPlug />
      <WeWorkWith />
      <SellematicsTestimonials />
      <DemoContactForm />
    </>
  )
}

export default SellematicsIndexPage
